import ArrowForward from '@mui/icons-material/ArrowForward';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Button,
  CircularProgress,
  FormControl,
  InputAdornment,
  Switch as MaterialSwitch,
  TextField,
  Theme,
  Tooltip,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import makeStyles from '@mui/styles/makeStyles';
import { GridRowData } from '@mui/x-data-grid';
import clsx from 'clsx';
import { OptionsObject, SnackbarKey } from 'notistack';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';
import {
  SetterOrUpdater,
  useRecoilStateLoadable,
  useRecoilValueLoadable,
} from 'recoil';
import { v4 as uuidv4 } from 'uuid';
import { useBusinessPermissions } from '../../common/helperFunctions/useBusinessPermissions';
import { IUserAtom, user } from '../../recoil/atoms/user';
import { methodNameEnum } from '../../recoil/selectors/makePHPRequest';
import { getApiMutation } from '../../services/rest/getApiMutation';
import {
  endpointEnum,
  makeAPIRequest,
  makeApiRequestCached,
} from '../../services/rest/makeAPIRequest';
import { LeaderboardSlideForm } from '../components/modals/LeaderboardSlideForm';
import {
  IAlertWithProgressBar,
  useSnackbarWithStyles,
} from '../components/notifications/SnackbarProviderWithStyles';
import dataTableScss from '../modules/Manage/pages/queues-table/data-table.module.css';
import {
  DataTable,
  IColDef,
  IToolbarComponent,
} from '../modules/Manage/pages/queues-table/DataTable';
import {
  EnhancedTableToolbar,
  ToolbarAddDeleteButton,
} from '../modules/Manage/pages/queues-table/EnhancedTableToolbar';
import {
  Slide,
  SlideMetric,
  // SlidePeriod,
  SlideType,
} from '../pages/leaderboard/Slide';

const metricsTitleMap = {
  'All Connections,allconnections': 'All Connections',
  'Answered Calls,allanswered': 'Answered Calls - All Answered',
  allanswered: 'Answered Calls - All Answered',
  'Missed Calls,allmissed': 'Missed Calls - All Missed',
  'Outgoing Calls,alloutgoing': 'Outgoing Calls - All Outgoing',
  alloutgoing: 'Outgoing Calls - All Outgoing',
  allconnections: 'All Connections',
  'Answered,outgoinganswered': 'Answered - Outgoing Calls',
  'Missed,outgoingmissed': 'Missed - Outgoing Missed',
  'Connections,outgoingconnection': 'Connections - Outgoing Connections',
  'Incoming Calls,allincoming': 'Incoming Calls - All Incoming',
  'Answered,incominganswered': 'Answered - Incoming Answered',
  'Missed,incomingmissed': 'Missed - Incoming Missed',
  'Connections,incomingconnection': 'Connections - Incoming Connections',
  'Total Duration,tduration': 'Total Duration',
  'Avg. Duration,alldurationavgmin': 'Average Duration',
};

const durationsMap = {
  '15seconds': '15 seconds',
  '30seconds': '30 seconds',
  '1minute': '1 minute',
  '5minutes': '5 minutes',
};

const CallRoutingToggle = (props: {
  params: any;
  mutation: any;
  // mutation: UseMutationResult<
  //   AxiosResponse<any>,
  //   unknown,
  //   {
  //     endpoint: string;
  //     payload?:
  //       | {
  //           [key: string]: any;
  //         }
  //       | undefined;
  //     method?: Method | undefined;
  //     omitBusinessIdAndApikey?: boolean | undefined;
  //   },
  //   unknown
  // >;
  enqueueSnackbarWithStyles: (
    alertComponentProps: IAlertWithProgressBar,
    snackbarProps?: OptionsObject | undefined
  ) => SnackbarKey | null;
  setRefetchToggleForLeaderboards: SetterOrUpdater<any>;
  userAtom: IUserAtom;
  disabled?: boolean;
  leaderboardId: string;
  leaderboardName: string;
  rows: (Slide & SlideRow)[];
  resetStates: any;
}) => {
  const [checked, setChecked] = useState<boolean>(
    Boolean(props.params?.active === 1)
  );
  useEffect(() => {
    setChecked(
      Boolean(props?.params?.active === 1 || props.params?.active === true)
    );
  }, [props?.params?.active]);
  const handleChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ): Promise<void> => {
    setChecked(checked);

    const r = props.rows.map((row: Slide & SlideRow) => {
      if (row.id === props.params.id) {
        return { ...row, active: checked ? 1 : 0 };
      } else {
        return row;
      }
    });
    try {
      const payload = {
        // businessid: userAtomContents?.businessid,
        businessid: props.userAtom.userid,
        leaderboardId: props.leaderboardId,
        leaderboardName: props.leaderboardName,
        createdById: null,
        slides: JSON.stringify(r),
      };

      const upsertRes = await props.mutation.mutateAsync({
        domain: process.env.VITE_APP_CDK_DOMAIN,
        endpoint: endpointEnum.UPSERT_LEADERBOARD,
        method: 'post',
        payload,
      });
      if (upsertRes?.data?.success) {
        props.setRefetchToggleForLeaderboards({});
        props.enqueueSnackbarWithStyles({
          message: `Successfully updated slide active status`,
          alertProps: { severity: 'success' },
        });
      } else {
        props.enqueueSnackbarWithStyles({
          message: `Error updating slide active status`,
          alertProps: { severity: 'error' },
        });
      }
      // setDeleteIndex('');
      props.resetStates();
    } catch (e) {
      props.enqueueSnackbarWithStyles({
        message: `Error updating slide active status`,
        alertProps: { severity: 'error' },
      });
    }
  };
  return (
    <MaterialSwitch
      checked={checked}
      onChange={handleChange}
      color="primary"
      name="status"
      inputProps={{ 'aria-label': 'primary checkbox' }}
      disabled={props.disabled}
    />
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  fullWidth: {
    width: '100% !important',
  },
  actionColumn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  deleteIconButton: {
    color: theme.custom.button.delete.main,
  },
  numbersList: {
    padding: '0',
    paddingBottom: '1px',
    listStyleType: 'none',
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  button: {
    marginLeft: theme.spacing(1), // space between fields
  },
  labels: {
    marginBottom: 0,
    paddingBottom: 0,
    fontSize: '12px',
  },
  formContainer: {
    marginTop: '20px',
    marginBottom: '30px',
    width: '60%',
  },
  field: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
  },
  disabledButton: {
    color: 'grey',
  },
  previewButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  agentsSlideButton: {
    minWidth: 133,
  },
  queuesSlideButton: {
    minWidth: 134,
  },
  helpTextRow: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
}));

interface SlideRow {
  slideName: string;
  id?: string;
  slide: string;
}

export const LeaderboardSlides = () => {
  const [leaderboardName, setLeadboardName] = useState('');
  const [addingNew, setAddingNew] = useState(false);
  const [open, setOpen] = useState<boolean[]>([]);
  const [openIndex, setOpenIndex] = useState<string | number | undefined>('');
  const [deleteIndex, setDeleteIndex] = useState<string | number | undefined>(
    ''
  );
  useEffect(() => {
    return () => {
      // Clean up the URL by removing the query parameter
      window.history.replaceState({}, '', window.location.pathname);
    };
  }, []);
  const resetStates = () => {
    if (newLeaderboard && rows.length === 1) {
      rows.pop();
    }
    setOpenIndex('');
    if (addingNew) {
      setOpen(new Array(rows?.length ?? 0).fill(false));
      rows.pop();
    } else {
      // ???
      setOpen(
        new Array(
          rows.length === 0
            ? 0
            : typeof rows?.length === 'number'
            ? rows?.length - 1
            : 0
        ).fill(false)
      );
    }
    setAddingNew(false);
    setDeleteIndex('');
    setNn([]);
  };
  const resetStatesOnCancel = () => {
    if (newLeaderboard && rows?.length === 1) {
      rows.pop();
    }

    if (addingNew) {
      setOpen(
        new Array(
          rows.length === 0
            ? 0
            : typeof rows?.length === 'number'
            ? rows?.length - 1
            : 0
        ).fill(false)
      );
      rows.pop();
    } else {
      setOpen(new Array(rows.length === 0 ? 0 : rows?.length ?? 0).fill(false));
    }
    setOpenIndex('');
    setAddingNew(false);
    setDeleteIndex('');
    setNn([]);
  };
  const [, setUserAtom] = useRecoilStateLoadable(user);
  // const [, setDeleteCancelTokenSource] = useState<
  //   CancelTokenSource | undefined
  // >();
  const [selected, setSelected] = useState<GridRowData[]>([]);
  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();
  const { id } = useParams<{ id: string }>();
  const addParam = new URLSearchParams(window.location.search).getAll(
    'add'
  )?.[0];
  const pathArr = window.location.pathname.split('/');
  const newLeaderboard = pathArr[pathArr.length - 1] === 'new';

  const userAtomLoadable = useRecoilValueLoadable(user);
  const userAtomContents = userAtomLoadable.contents as IUserAtom;

  const dataUsers = {
    call: methodNameEnum.GET_BUSINESS_USERS,
  };
  const businessUsersLoadable = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: endpointEnum.GET_BUSINESS_USERS,
      payloadJsonString: JSON.stringify(dataUsers),
    })
  );
  const users = useMemo(
    () =>
      businessUsersLoadable.state === 'hasValue'
        ? businessUsersLoadable.contents?.response?.data?.result.filter(
            (user) => user.isactive === 1
          )
        : [],
    [businessUsersLoadable]
  );

  const [
    __,
    leaderboardsLoadable,
    setRefetchToggleForLeaderboards,
  ] = makeApiRequestCached(
    {
      domain: process.env.VITE_APP_CDK_DOMAIN,
      endpoint: endpointEnum.GET_LEADERBOARDS,
      payloadJsonString: JSON.stringify({
        apikey: userAtomContents?.apikey,
        businessid: userAtomContents?.businessid,
        businessId: userAtomContents?.businessid,
      }),
    },
    (loadable, cached) =>
      loadable.contents?.response?.data?.result ?? cached.current
  );
  const leaderboardsCached = useRef({} as any);
  leaderboardsCached.current = useMemo(
    () =>
      leaderboardsLoadable.state === 'hasValue'
        ? leaderboardsLoadable.contents?.response?.data?.data?.map(
            (a: any) => ({
              ...a,
              id: a.leaderboardId,
            })
          )
        : leaderboardsCached.current,
    [leaderboardsLoadable, userAtomContents]
  );

  const businessTeams = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: endpointEnum.GET_BUSINESS_TEAMS,
      payloadJsonString: JSON.stringify({
        call: methodNameEnum.GET_BUSINESS_TEAMS,
      }),
    })
  );
  type Team = {
    lastUpdated: string;
    memberCount: number;
    teamId: number;
    teamid: number;
    teamname: string;
  };
  // get businessTeams that do not belong to queue
  const teamsList = useRef<Team[]>([]);
  teamsList.current = useMemo(() => {
    if (businessTeams.state === 'loading') {
      return teamsList.current;
    }
    const teams =
      [
        {
          lastUpdated: '',
          memberCount: 0,
          teamid: 0,
          teamId: 0,
          teamname: 'All Agents',
        },
        ...(businessTeams.contents?.response?.data?.result ?? []),
      ]
        ?.sort((a: Team, b: Team) =>
          a?.teamname?.toLowerCase()?.localeCompare(b?.teamname?.toLowerCase())
        )
        .map((elem: any) => ({ ...elem, teamId: elem?.teamid })) ?? [];

    teams.unshift({
      lastUpdated: '',
      memberCount: 0,
      teamid: 0,
      teamId: 0,
      teamname: 'All Agents',
    });
    return teams;
  }, [businessTeams]);

  const classes = useStyles();

  const generateSlideTitle = (s: {
    metric: string;
    type: 'agent' | 'queue';
    queueid?: Record<string, any>;
  }) => {
    if (s.metric in metricsTitleMap && s.type === 'agent') {
      return metricsTitleMap[s.metric];
    } else {
      return `Queue Slide${
        s?.queueid?.queuename ? ' - ' + s?.queueid?.queuename : ''
      }`;
    }
  };
  const [value, setValue] = useState('');
  const rows = useMemo<(Slide & SlideRow)[]>(() => {
    if (leaderboardsLoadable.state === 'hasValue') {
      const slideData = leaderboardsLoadable?.contents?.response?.data?.data?.filter(
        (l) => l.leaderboardId == id
      );
      setLeadboardName(
        slideData?.[0]?.name ??
          `Leaderboard ${
            (leaderboardsLoadable?.contents?.response?.data?.data?.length ??
              0) + 1
          }`
      );
      setValue(
        slideData?.[0]?.name ??
          `Leaderboard ${
            (leaderboardsLoadable?.contents?.response?.data?.data?.length ??
              0) + 1
          }`
      );
      const slides = JSON.parse(slideData?.[0]?.slides ?? '[]');
      if (open.length === 0) {
        setOpen(new Array(slides?.length).fill(false));
      }
      const slidesArr = slides?.map((s, idx) => ({
        ...s,
        id: uuidv4(),
        order: idx,
        active: s.active,
        slide: generateSlideTitle(s),
      }));
      if (addParam === 'agent' || addParam === 'queue') {
        slidesArr.unshift({
          slide: 'NEW SLIDE',
          type: addParam,
          id: uuidv4(),
          active: 1,
        });
        const a = new Array(slidesArr?.length).fill(false);
        a[0] = true;
        setOpen(a);
        setOpenIndex(0);
      }
      window.history.replaceState(
        {},
        '',
        window.location.pathname + window.location.search
      );
      return slidesArr ?? [];
    }
  }, [leaderboardsLoadable]);

  const [nn, setNn] = useState<Slide[]>([]);
  const [editingName, setEditingName] = useState(false);
  const [nameLoading, setNameLoading] = useState(false);
  const [nameTakenError, setNameTakenError] = useState(false);

  const handleNameSave = async () => {
    // Check if leaderboard name is already taken first
    for (const lb of leaderboardsLoadable?.contents?.response?.data?.data ??
      []) {
      if (lb.name === value) {
        setNameTakenError(true);
        return;
      }
    }
    setNameTakenError(false);
    if (newLeaderboard) {
      setLeadboardName(value);
      setEditingName(false);
      return;
    }

    setNameLoading(true);
    const payload = {
      businessid: userAtomContents?.businessid,
      leaderboardId: id,
      leaderboardName: value,
      createdById: userAtomContents?.userid,
      slides: JSON.stringify(rows),
    };

    const upsertRes = await mutation.mutateAsync({
      domain: process.env.VITE_APP_CDK_DOMAIN,
      endpoint: endpointEnum.UPSERT_LEADERBOARD,
      method: 'post',
      payload,
    });
    setNameLoading(false);
    setEditingName(false);
    if (upsertRes?.data?.success) {
      setRefetchToggleForLeaderboards({});
      enqueueSnackbarWithStyles({
        message: `Leaderboard name updated`,
        alertProps: { severity: 'success' },
      });
    } else {
      enqueueSnackbarWithStyles({
        message: `Something went wrong, name was not updated`,
        alertProps: { severity: 'error' },
      });
    }
  };
  const ToolbarComponent = useCallback(
    (props: IToolbarComponent) => (
      <>
        <EnhancedTableToolbar
          {...props}
          isLoading={leaderboardsLoadable.state === 'loading'}
          dataType="RoutingRules"
          numSelected={selected.length}
          hideVerticalDivider={true}
          rightComponent={
            <>
              <Tooltip title="Preview">
                <span>
                  <Button
                    name="Preview"
                    variant="contained"
                    startIcon={<ArrowForward />}
                    color="primary"
                    onClick={() => {
                      window.location.href = `/leaderboard/${id}`;
                    }}
                    disableElevation
                    className={classes.previewButton}
                    disabled={
                      (rows?.filter((r) => r.active)?.length ?? 0) === 0 ||
                      openIndex !== ''
                    }
                  >
                    Preview
                  </Button>
                </span>
              </Tooltip>
              <ToolbarAddDeleteButton
                addButtonText="Agents slide"
                onClickForAdd={() => {
                  setAddingNew(true);
                  // history.push('/manage/numbers/routing/add');
                  rows.push({
                    type: SlideType.agent,
                    slide: 'NEW SLIDE',
                    active: true,
                    metric: SlideMetric.allconnections,
                    teamId: 0,
                    slideName: `Leaderboard ${(rows?.length ?? 0) + 1}`,
                    // createdById: '117454',
                    pages: [],
                    slideDurationInSec: '' as any,
                    slideId: uuidv4(),
                    // timePeriod: SlidePeriod.day,
                    timePeriod: '' as any,
                    showAllUsers: true,
                    // slideDurationInSec: '30seconds',
                  });
                  setNn(rows);
                  setOpenIndex(rows.length - 1);
                  const openCopy = [...open];
                  openCopy.push(true);
                  setOpen(openCopy);
                }}
                isLoading={props.isLoading}
                disabled={
                  ((rows?.filter((r) => r.active)?.length ?? 0) === 0 ||
                    openIndex !== '') &&
                  rows?.length !== 0
                }
                className={classes.agentsSlideButton}
              />
              <ToolbarAddDeleteButton
                addButtonText="Queues slide"
                onClickForAdd={() => {
                  setAddingNew(true);
                  rows.push({
                    type: SlideType.queue,
                    active: true,
                    slide: 'NEW SLIDE',
                    queueId: uuidv4().toString(),
                    queueid: {
                      queueid: -1,
                      // queuename: `Leaderboard ${rows?.length + 1 ?? 1}`,
                      queuename: '',
                    },
                    slideDurationInSec: 78,
                    slideId: uuidv4(),
                    slideName: `Leaderboard ${(rows?.length ?? 0) + 1}`,
                  });
                  setNn(rows);
                  setOpenIndex(rows.length - 1);
                  const openCopy = [...open];
                  openCopy.push(true);
                  setOpen(openCopy);
                }}
                isLoading={props.isLoading}
                disabled={
                  ((rows?.filter((r) => r.active)?.length ?? 0) === 0 ||
                    openIndex !== '') &&
                  rows?.length !== 0
                }
                className={classes.queuesSlideButton}
              />
            </>
          }
          hideSearch={true}
          csvData={undefined}
          smallerCenterComponent={true}
          // centerComponent={}
          leftComponent={
            <>
              <div
                style={{
                  marginLeft: '20px',
                  width: '230%',
                  display: 'contents',
                }}
              >
                <h3
                  style={{
                    marginRight: 8,
                    marginBottom: 0,
                    minWidth: 145,
                    fontSize: 18,
                  }}
                >
                  Slide Settings for
                </h3>
                {nameLoading ? (
                  <CircularProgress size={30} />
                ) : !editingName ? (
                  <>
                    <p
                      onClick={() => setEditingName(true)}
                      style={{
                        fontSize: '17px',
                        marginBottom: 0,
                        fontWeight: 'bold',
                        minWidth: 120,
                      }}
                    >
                      {leaderboardName}
                    </p>
                    <IconButton
                      onClick={() => setEditingName(true)}
                      size="large"
                    >
                      <EditIcon color="primary" fontSize="small" />
                    </IconButton>
                  </>
                ) : (
                  <FormControl>
                    {/* <p>This name is already being used for a leaderboard</p> */}
                    <TextField
                      id="standard-basic"
                      error={nameTakenError}
                      helperText={
                        nameTakenError
                          ? 'This name is already being used for a leaderboard'
                          : ''
                      }
                      value={value}
                      variant="outlined"
                      style={{ paddingBottom: '0px' }}
                      label="Title"
                      onBlur={async () => {
                        if (!nameTakenError) {
                          setEditingName(false);
                        }
                        handleNameSave();
                      }}
                      autoFocus
                      onChange={(e) => {
                        setValue(e.target.value);
                      }}
                      onKeyDown={async (event) => {
                        if (event.key === 'Enter' || event.key === 'Escape') {
                          if (value !== leaderboardName) {
                            await handleNameSave();
                          }
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <div>
                              <Tooltip title={'Confirm'}>
                                <span>
                                  <IconButton
                                    style={{ padding: 0 }}
                                    aria-label="accept"
                                    onMouseDown={async (
                                      event: React.MouseEvent<HTMLElement>
                                    ) => {
                                      await handleNameSave();
                                    }}
                                    disabled={value === leaderboardName}
                                    size="large"
                                  >
                                    <CheckIcon
                                      color={
                                        value === leaderboardName
                                          ? 'disabled'
                                          : 'primary'
                                      }
                                    />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              <Tooltip title="Cancel">
                                <span>
                                  <IconButton
                                    style={{ padding: 0 }}
                                    aria-label="cancel"
                                    disabled={false}
                                    onClick={() => {
                                      setEditingName(false);
                                      setValue(leaderboardName);
                                      setNameTakenError(false);
                                    }}
                                    size="large"
                                  >
                                    <ClearIcon style={{ color: 'red' }} />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </div>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {/* <p>This name is already being used for a leaderboard</p> */}
                  </FormControl>
                )}
              </div>
            </>
          }
        />
        <div className={classes.helpTextRow}>Rows are draggable to reorder</div>
      </>
    ),
    [
      leaderboardsLoadable,
      selected.length,
      open,
      editingName,
      value,
      nameLoading,
      leaderboardName,
      nameTakenError,
    ]
  );

  const mutation = useMutation(getApiMutation(userAtomContents, setUserAtom));

  const readOnly = useBusinessPermissions().accountReadOnly;

  const columns = useMemo<IColDef[]>(
    () => [
      {
        field: 'order',
        headerName: 'Order',
        hide: readOnly,
        disableExport: true,
        headerAlign: 'center',
        align: 'center',
        dragTableWidth: '3%',
      },
      {
        field: 'active',
        headerName: 'Active',
        headerAlign: 'center',
        align: 'center',
        headerClassName: dataTableScss.fullWidth,
        cellClassName: dataTableScss.fullWidth,
        dragTableWidth: '5%',
        renderCell: (params) => {
          return (
            <>
              <div className={clsx(classes.actionColumn, 'row')}>
                <CallRoutingToggle
                  params={params}
                  mutation={mutation}
                  enqueueSnackbarWithStyles={enqueueSnackbarWithStyles}
                  setRefetchToggleForLeaderboards={
                    setRefetchToggleForLeaderboards
                  }
                  userAtom={userAtomContents}
                  leaderboardId={id}
                  leaderboardName={leaderboardName}
                  rows={rows}
                  resetStates={resetStates}
                />
              </div>
            </>
          );
        },
        disableExport: true,
      },
      {
        field: 'slide',
        headerName: 'Slide Metric',
        headerAlign: 'left',
        align: 'center',
        headerClassName: dataTableScss.fullWidth,
        cellClassName: dataTableScss.fullWidth,
        dragTableWidth: '5%',
      },
      {
        field: 'team',
        headerName: 'Team',
        headerAlign: 'left',
        align: 'center',
        headerClassName: dataTableScss.fullWidth,
        cellClassName: dataTableScss.fullWidth,
        dragTableWidth: '5%',
        valueFormatter: (params) => {
          const teamName = teamsList.current?.find(
            (val) => val?.teamId === params?.row?.teamId // Access from params.row
          )?.teamname;
          return teamName ?? '';
        },
      },
      {
        field: 'duration',
        headerName: 'Duration',
        headerAlign: 'left',
        align: 'center',
        headerClassName: dataTableScss.fullWidth,
        cellClassName: dataTableScss.fullWidth,
        dragTableWidth: '5%',
        valueFormatter: (params) => {
          return durationsMap?.[params?.row?.slideDurationInSec] ?? '';
        },
      },
      {
        field: 'id',
        headerName: 'Actions',
        hide: readOnly,
        cellClassName: classes.actionColumn,
        disableExport: true,
        disableSearch: true,
        headerAlign: 'center',
        disableRowSelection: true,
        enableSorting: false,
        dragTableWidth: '10%',
        renderCell: (slideuuid: any) => {
          const params = rows?.map((r) => r.id).indexOf(slideuuid);
          return (
            <div>
              {deleteIndex === params ? (
                <article className={clsx(classes.actionColumn)}>
                  {/* {flushSelected ? (
                  <div className={classes.fillerButton} />
                ) : (
                  <div
                    className={
                      props.noLeftIconMargin
                        ? classes.noLeftIconMargin
                        : classes.fillerButton2
                    }
                  />
                )} */}
                  <Tooltip title={'Confirm'}>
                    <span>
                      <IconButton
                        aria-label="accept"
                        onClick={async (
                          event: React.MouseEvent<HTMLElement>
                        ) => {
                          if (newLeaderboard) {
                            resetStates();
                            rows.pop();
                            return;
                          }
                          // cut this index from the rows
                          const slicedRows = [...rows];
                          slicedRows.splice(params, 1);
                          const payload = {
                            businessid: userAtomContents?.businessid,
                            leaderboardId: id,
                            leaderboardName,
                            createdById: null,
                            slides: JSON.stringify(slicedRows),
                          };

                          const upsertRes = await mutation.mutateAsync({
                            domain: process.env.VITE_APP_CDK_DOMAIN,
                            endpoint: endpointEnum.UPSERT_LEADERBOARD,
                            method: 'post',
                            payload,
                          });
                          if (upsertRes?.data?.success) {
                            setRefetchToggleForLeaderboards({});
                            enqueueSnackbarWithStyles({
                              message: `Successfully deleted slide`,
                              alertProps: { severity: 'success' },
                            });
                          } else {
                            enqueueSnackbarWithStyles({
                              message: `Something went wrong, slide failed to delete`,
                              alertProps: { severity: 'error' },
                            });
                          }
                          setDeleteIndex('');
                          resetStates();
                        }}
                        // disabled={props.isLoading}
                        disabled={false}
                        size="large"
                      >
                        <CheckIcon
                          // color={props.isLoading ? 'disabled' : 'primary'}
                          color={'primary'}
                        />
                        {/* {props.isLoading && ( */}
                        {false && (
                          <CircularProgress
                            size={43}
                            // className={classes.buttonProgress}
                          />
                        )}
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title="Cancel">
                    <span>
                      <IconButton
                        aria-label="cancel"
                        onClick={(event: React.MouseEvent<HTMLElement>) => {
                          setDeleteIndex('');
                        }}
                        // disabled={props.isLoading}
                        disabled={false}
                        size="large"
                      >
                        <ClearIcon
                          style={{ color: 'red' }}
                          // color="disabled"
                          // className={clsx({
                          //   [classes.deleteIconButton]: !props.isLoading, // || props.deleteCancelTokenSource,
                          // })}
                        />
                      </IconButton>
                    </span>
                  </Tooltip>
                  {/* place after article: <p>Delete is irreversible</p> */}
                </article>
              ) : (
                <div className={clsx(classes.actionColumn)}>
                  <Tooltip title="Edit">
                    <span>
                      <IconButton
                        // className={classes.disabledButton}
                        style={{ color: 'grey' }}
                        disabled={
                          openIndex === ''
                            ? false
                            : openIndex !== '' && params !== openIndex
                        }
                        onClick={() => {
                          if (openIndex === '') {
                            setOpenIndex(params);
                          } else {
                            setOpenIndex('');
                          }
                          setOpen((st) => {
                            const g = [...st];
                            g[params] = !g[params];
                            return g;
                          });
                        }}
                        name="edit"
                        size="large"
                      >
                        <CreateIcon
                          color={
                            openIndex === '' || params === openIndex
                              ? 'primary'
                              : 'disabled'
                          }
                        />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <span>
                      <IconButton
                        name="delete"
                        onClick={() => {
                          setDeleteIndex(params);
                        }}
                        size="large"
                      >
                        <DeleteIcon className={classes.deleteIconButton} />
                      </IconButton>
                    </span>
                  </Tooltip>
                </div>
              )}
            </div>
          );
        },
      },
    ],
    [classes, open, nn, openIndex, leaderboardsLoadable, deleteIndex, rows]
  );

  const p = {
    data: addingNew ? nn : rows,
    openIndex,
    leaderboardId: id,
    defaultMetric: 'Missed Calls,allmissed',
    setRefetchToggleForLeaderboards,
    resetStates,
    resetStatesOnCancel,
    addIngNew: addingNew,
    setAddingNew,
    numbUsers: users?.length,
    leaderboardName,
    numbLeaderboards: leaderboardsCached.current?.length,
    newLeaderboard,
    teamsList,
  };

  const onDragEndHandler = async (draggedId, currPos, tarPos) => {
    // target pos looks like its not 0 indexed, but curr pos is
    const rowsCopy = [...rows];
    const temp = rowsCopy[tarPos - 1];
    rowsCopy[tarPos - 1] = rowsCopy[currPos];
    rowsCopy[currPos] = temp;

    const payload = {
      businessid: userAtomContents?.businessid,
      leaderboardId: id,
      leaderboardName: leaderboardName,
      createdById: null,
      slides: JSON.stringify(rowsCopy),
    };

    const upsertRes = await mutation.mutateAsync({
      domain: process.env.VITE_APP_CDK_DOMAIN,
      endpoint: endpointEnum.UPSERT_LEADERBOARD,
      method: 'post',
      payload,
    });
    if (upsertRes?.data?.success) {
      setRefetchToggleForLeaderboards({});
      enqueueSnackbarWithStyles({
        message: `Successfully re-ordered slides`,
        alertProps: { severity: 'success' },
      });
    } else {
      enqueueSnackbarWithStyles({
        message: `Something went wrong, slide failed to re-order`,
        alertProps: { severity: 'error' },
      });
    }
    resetStates();
  };

  const onDragMouseDown = () => {
    setOpenIndex('');
    setOpen(new Array(open?.length ?? 0).fill(false));
  };
  const onDragMouseUp = () => {
    // console.log('mouse up');
  };

  return (
    <>
      <DataTable
        hideLastPageButton={true}
        rows={(nn.length ? nn : rows) as any}
        columns={columns}
        loading={leaderboardsLoadable.state === 'loading'}
        ToolbarComponent={ToolbarComponent}
        draggable2={true}
        onDragEnd={onDragEndHandler}
        onDragMouseDown={onDragMouseDown}
        onDragMouseUp={onDragMouseUp}
        setDragSelected={(selected: GridRowData[]) => setSelected(selected)}
        openArr={open}
        slideComponent={LeaderboardSlideForm}
        slideComponentProps={p}
      />
    </>
  );
};
